export default "__VITE_ASSET__CvIat5O$__"